export class Range {
  constructor(public min: number, public max: number) {}
}
